import { render, staticRenderFns } from "./CrawlerTaskPanel.vue?vue&type=template&id=bef9aea0&scoped=true"
import script from "./CrawlerTaskPanel.vue?vue&type=script&lang=js"
export * from "./CrawlerTaskPanel.vue?vue&type=script&lang=js"
import style0 from "./CrawlerTaskPanel.vue?vue&type=style&index=0&id=bef9aea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef9aea0",
  null
  
)

export default component.exports